import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import RightsholderContactInformation from '@Scenes/RightsholderScene/RightsholderContactInformation'
import RightsholderContactList from '@Scenes/RightsholderScene/RightsholderContactList'
import RightsholderMaintenanceUserPermissionsProfile from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile'
import RightsholderMaintenanceUserPermissions from '@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissions'
import RightsholderMaintenance from '@Scenes/RightsholderScene/RightsholderMaintenance'
import MemberBenefits from '@Components/MemberBenefits'
import React from 'react'

export const createMaintenanceRoutes = () => [
    {
        path: RIGHTSHOLDER_SUB_ROUTES.maintenance.rightsholderContact,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderContactInformation />
            </PermissionCheck>
        ),
    },
    {
        path: RIGHTSHOLDER_SUB_ROUTES.maintenance.rightsholderContacts,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderContactList />
            </PermissionCheck>
        ),
    },
    {
        path: RIGHTSHOLDER_SUB_ROUTES.maintenance.userPermission,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.SUPER_USER_PERMISSIONS.manage_user_permissions]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderMaintenanceUserPermissionsProfile />
            </PermissionCheck>
        ),
    },
    {
        path: RIGHTSHOLDER_SUB_ROUTES.maintenance.userPermissions,
        element: (
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.SUPER_USER_PERMISSIONS.manage_user_permissions]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
            >
                <RightsholderMaintenanceUserPermissions />
            </PermissionCheck>
        ),
    },
    {
        path: RIGHTSHOLDER_SUB_ROUTES.maintenance.root,
        element: (
            <PermissionCheck
                requiredPermissions={[
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                    PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                ]}
                orIsInternal
                reRouteLocation={Navigation.home.root()}
                bypassRestriction
            >
                <RightsholderMaintenance />
            </PermissionCheck>
        ),
    },
    {
        path: RIGHTSHOLDER_SUB_ROUTES.benefits,
        element: <MemberBenefits />,
    },
]
